export const BASE_URLS = {
  FILE_SERVER: process.env.REACT_APP_FILESERVER + "api",
  DAGS_SERVER: process.env.REACT_APP_DAGSERVER + "api",
  AUTH_SERVER: process.env.REACT_APP_AUTHSERVER,
  ELT_SFTP_SERVER: process.env.REACT_APP_ETL_SFTP + "api",
}

export default {
  DAGS: `${BASE_URLS.DAGS_SERVER}/dags`,
  DAGS_RULES_ID: (dags_id: string) =>
    `${BASE_URLS.DAGS_SERVER}/dag_rules/${dags_id}`,
  SHOW_JSONS: () => `${BASE_URLS.FILE_SERVER}/show_jsons`,
  JSON_ID: (json_id: string) => `${BASE_URLS.FILE_SERVER}/jsons/${json_id}`,
  PUT_JSON: `${BASE_URLS.FILE_SERVER}/put_json`,
  ELT_DIRECTORY: (path?: string) =>
    `${BASE_URLS.ELT_SFTP_SERVER}/files/${path || ""}`,
  UPLOAD_FILE: (path: string) => `${BASE_URLS.ELT_SFTP_SERVER}/put/${path}`,
  FETCH_FILE: (path: string) => `${BASE_URLS.ELT_SFTP_SERVER}/get/${path}`,
  REMOVE_FILE: (path: string) => `${BASE_URLS.ELT_SFTP_SERVER}/rm/${path}`,
  REMOVE_DIR: (path: string) => `${BASE_URLS.ELT_SFTP_SERVER}/rmdir/${path}`,
  CREATE_DIR: (path: string) => `${BASE_URLS.ELT_SFTP_SERVER}/mkdir/${path}`,
  DAGS_EXTRACT: (id: string) => `${BASE_URLS.DAGS_SERVER}/extract/${id}`,
  DAGS_TRANSFORM: (id: string) => `${BASE_URLS.DAGS_SERVER}/transform/${id}`,
  DAGS_LOAD: (id: string) => `${BASE_URLS.DAGS_SERVER}/load/${id}`,
  DAGS_PUBLISH: (id: string) => `${BASE_URLS.DAGS_SERVER}/publish/${id}`,
  ACCESSES: `${BASE_URLS.DAGS_SERVER}/access_roles`,
  DATA_LICENCES: `${BASE_URLS.DAGS_SERVER}/data_licences`,
  DATA_ORGANISATIONS: `${BASE_URLS.DAGS_SERVER}/data_organisations`,
  GEO_LEVEL: `${BASE_URLS.DAGS_SERVER}/geo_level`,
}
